module.exports = __webpack_public_path__ + "static/media/enhanced-logo.b3626c7a.png";